import { useContext } from "react";
import appIcon from "../images/app_icon.jpg"
import "../styles/PlayerCards.css"
import PlayerInfoContext from "../context/PlayerInfoContext";
import PlayerCardItem from "./items/PlayerCardItem";
import { jwtDecode } from "jwt-decode";
function PlayerCards({ size, collectedCards }) {
    const playerInfo = useContext(PlayerInfoContext);
    const localDetails = jwtDecode(localStorage.getItem("token"));
    if (!playerInfo?.cards && !collectedCards) {
        return <div></div>
    }
    return (
        <div className={`player-cards-container-${size}`}>
            <div style={{ display: "flex" }}>
                <img src={collectedCards ? appIcon : localDetails.picture} alt="" style={{ width: `${size === "lg" ? "3vw" : "40px"}`, height: `${size === "lg" ? "3vw" : "40px"}`, borderRadius: `${size === "lg" ? "1.5vw" : "20px"}`, marginRight: "10px" }} />
                <div className={`player-cards-header`}>
                    {collectedCards ? "Colledted Cards" : "Your Cards"}
                </div>
            </div>
            <div>
                {(collectedCards || playerInfo.cards).map((card, index) => {
                    return <PlayerCardItem key={collectedCards ? `collected_card_${index}` : `card_${index}`} size={size} card={card} />
                })}
                {(collectedCards || playerInfo.cards).length === 0 && <p style={{ textAlign: "center" }} >No cards</p>}
            </div>
        </div>
    )
}

export default PlayerCards;